import firebase from '../../firebase/compat';

// Het URL-segment van één ingevulde vragenlijst. Moderne links serialiseren de
// Firestore-timestamp als "seconden-nanoseconden" (volledige precisie, want de
// responses worden per milliseconde gegroepeerd); oudere links dragen een
// gewone datumtekst.
// AI-CONTEXT: See docs/pitfalls.md#database-responses-grouped-by-millisecond-timestamp
const SERIALIZED = /^\d+-\d+$/;

/**
 * Leest het tijdstempel-segment uit een resultaten-URL.
 *
 * Geeft `null` als het segment ontbreekt of geen datum is — óók bij de
 * sentinel-teksten 'undefined'/'null' die een leeg URL-segment kan dragen.
 * Aanroepers geven dat door aan een query als `''`, nooit als `null`: `null` is
 * voor Firestore een echte waarde en zou een query opleveren die stil niets
 * vindt.
 * AI-CONTEXT: See docs/pitfalls.md#database-firestore-null-is-a-valid-query-value
 * AI-CONTEXT: See docs/pitfalls.md#database-url-sentinel-string-persisted
 *
 * @param {string} [param] - Het URL-segment.
 * @returns {firebase.firestore.Timestamp | null} De timestamp, of null.
 */
const parseTimestampParam = (param) => {
    if (!param) return null;

    if (SERIALIZED.test(param)) {
        const [secondsStr, nanosecondsStr] = param.split('-');
        return new firebase.firestore.Timestamp(
            parseInt(secondsStr, 10),
            parseInt(nanosecondsStr, 10)
        );
    }

    const date = new Date(param);
    if (Number.isNaN(date.getTime())) return null;

    return firebase.firestore.Timestamp.fromDate(date);
};

export default parseTimestampParam;
